/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { FiatDepositInstructionCreateRequest } from '../model/fiatDepositInstructionCreateRequest';
// @ts-ignore
import { FiatDepositInstructionDto } from '../model/fiatDepositInstructionDto';
// @ts-ignore
import { FiatDepositInstructionUpdateRequest } from '../model/fiatDepositInstructionUpdateRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CreateFiatDepositInstructionRequestParams {
  fiatDepositInstructionCreateRequest: FiatDepositInstructionCreateRequest;
}

export interface DeleteFiatDepositInstructionRequestParams {
  instructionId: number;
}

export interface GetFiatDepositInstructionsRequestParams {
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
}

export interface UpdateFiatDepositInstructionRequestParams {
  fiatDepositInstructionUpdateRequest: FiatDepositInstructionUpdateRequest;
}

@Injectable({
  providedIn: 'root',
})
export class FiatDepositInstructionControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Create fiat deposit instruction
   * @endpoint post /v1/fiat-deposit-instruction
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public createFiatDepositInstruction(
    requestParameters: CreateFiatDepositInstructionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<FiatDepositInstructionDto>;
  public createFiatDepositInstruction(
    requestParameters: CreateFiatDepositInstructionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<FiatDepositInstructionDto>>;
  public createFiatDepositInstruction(
    requestParameters: CreateFiatDepositInstructionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<FiatDepositInstructionDto>>;
  public createFiatDepositInstruction(
    requestParameters: CreateFiatDepositInstructionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fiatDepositInstructionCreateRequest = requestParameters?.fiatDepositInstructionCreateRequest;
    if (fiatDepositInstructionCreateRequest === null || fiatDepositInstructionCreateRequest === undefined) {
      throw new Error(
        'Required parameter fiatDepositInstructionCreateRequest was null or undefined when calling createFiatDepositInstruction.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/fiat-deposit-instruction`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<FiatDepositInstructionDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: fiatDepositInstructionCreateRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Delete fiat deposit instruction
   * @endpoint delete /v1/fiat-deposit-instruction/{instructionId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public deleteFiatDepositInstruction(
    requestParameters: DeleteFiatDepositInstructionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any>;
  public deleteFiatDepositInstruction(
    requestParameters: DeleteFiatDepositInstructionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<any>>;
  public deleteFiatDepositInstruction(
    requestParameters: DeleteFiatDepositInstructionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<any>>;
  public deleteFiatDepositInstruction(
    requestParameters: DeleteFiatDepositInstructionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const instructionId = requestParameters?.instructionId;
    if (instructionId === null || instructionId === undefined) {
      throw new Error(
        'Required parameter instructionId was null or undefined when calling deleteFiatDepositInstruction.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/fiat-deposit-instruction/${this.configuration.encodeParam({ name: 'instructionId', value: instructionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets all fiat deposit instructions
   * @endpoint get /v1/fiat-deposit-instruction
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getFiatDepositInstructions(
    requestParameters?: GetFiatDepositInstructionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<FiatDepositInstructionDto>>;
  public getFiatDepositInstructions(
    requestParameters?: GetFiatDepositInstructionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<FiatDepositInstructionDto>>>;
  public getFiatDepositInstructions(
    requestParameters?: GetFiatDepositInstructionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<FiatDepositInstructionDto>>>;
  public getFiatDepositInstructions(
    requestParameters?: GetFiatDepositInstructionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const businessEntity = requestParameters?.businessEntity;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/fiat-deposit-instruction`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<FiatDepositInstructionDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Updates fiat deposit instruction
   * @endpoint put /v1/fiat-deposit-instruction
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public updateFiatDepositInstruction(
    requestParameters: UpdateFiatDepositInstructionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<FiatDepositInstructionDto>;
  public updateFiatDepositInstruction(
    requestParameters: UpdateFiatDepositInstructionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<FiatDepositInstructionDto>>;
  public updateFiatDepositInstruction(
    requestParameters: UpdateFiatDepositInstructionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<FiatDepositInstructionDto>>;
  public updateFiatDepositInstruction(
    requestParameters: UpdateFiatDepositInstructionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fiatDepositInstructionUpdateRequest = requestParameters?.fiatDepositInstructionUpdateRequest;
    if (fiatDepositInstructionUpdateRequest === null || fiatDepositInstructionUpdateRequest === undefined) {
      throw new Error(
        'Required parameter fiatDepositInstructionUpdateRequest was null or undefined when calling updateFiatDepositInstruction.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/fiat-deposit-instruction`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<FiatDepositInstructionDto>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: fiatDepositInstructionUpdateRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
